import { defineMessages } from 'react-intl';

// 'Codice cliente',
//     'Intestatario',
//     'Figura accessoria',
//     'Data attivazione servizio',
//     'Stato',
//     'Email',
//     'Telefono'

export default defineMessages({
  titleTable: {
    id: 'adminConsole.resultsTable.titleTable',
    defaultMessage: 'Risultato ricerca cliente',
    description: 'Title of table',
  },
  labelClientCode: {
    id: 'adminConsole.resultsTable.labelClientCode',
    defaultMessage: 'Codice cliente',
    description: 'Client code column label',
  },
  labelAccountHolder: {
    id: 'adminConsole.resultsTable.labelAccountHolder',
    defaultMessage: 'Intestatario',
    description: 'Account holder column label',
  },
  labelFiguraAccessoria: {
    id: 'adminConsole.resultsTable.labelFiguraAccessoria',
    defaultMessage: 'Figura accessoria',
    description: 'Figura accessoria column label',
  },
  labelActivationDateService: {
    id: 'adminConsole.resultsTable.labelActivationDateService',
    defaultMessage: 'Data attivazione servizio',
    description: 'Activation date service column label',
  },
  labelState: {
    id: 'adminConsole.resultsTable.labelState',
    defaultMessage: 'Stato',
    description: 'State column label',
  },
  labelEmail: {
    id: 'adminConsole.resultsTable.labelEmail',
    defaultMessage: 'Email',
    description: 'Email column label',
  },
  labelPhone: {
    id: 'adminConsole.resultsTable.labelPhone',
    defaultMessage: 'Numero di cellulare',
    description: 'Phone column label',
  },
});
